import React from "react";
import "./App.css";
import ChessClock from "./components/ChessClock";

function App() {
  return (
    <div className="App">
      <ChessClock />
    </div>
  );
}

export default App;
